// extracted by mini-css-extract-plugin
export default {"header":"PaymentPage_header__Ke8mw","main":"PaymentPage_main__qnLNy","maxContainer":"PaymentPage_maxContainer__FY4pb","footer":"PaymentPage_footer__YAoui"};